var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$getPermission(_vm.$route.path + '/reset-project') && !_vm.project.isParent)?_c('div',{staticClass:"button",on:{"click":_vm.onClick}},[_c('a-icon',{staticStyle:{"font-size":"16px","margin-bottom":"8px"},attrs:{"type":"close-circle"}}),_c('span',[_vm._v("重置项目")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }